<template>
  <!-- Tooltip lives on the wrapper: a disabled v-btn has pointer-events: none -->
  <span class="d-inline-flex" title="Próximamente: reportes de esta aplicación en SmartView">
    <v-btn
      variant="text"
      class="mr-2 reports-btn"
      disabled
      aria-disabled="true"
      aria-label="Reportes (próximamente)"
    >
      <v-icon size="22">mdi-chart-bar</v-icon>
      <span class="ml-2 text-body-2 font-weight-medium d-none d-sm-inline">Reportes</span>
      <!-- Visible hint: title tooltips never show on touch screens -->
      <v-chip size="x-small" variant="tonal" label class="ml-1" data-test="reports-soon-chip">Pronto</v-chip>
    </v-btn>
  </span>
</template>

<script>
export default {
  name: 'ReportsComingSoonButton'
}
</script>

<style scoped>
/* Mirrors .hub-btn in AppHeader, whose scoped styles do not reach this component */
.reports-btn {
  text-transform: none !important;
  letter-spacing: normal !important;
  border-radius: 10px !important;
  padding: 4px 10px !important;
  min-height: 36px !important;
}
</style>
